import type { IndexPaging, Query } from '../inputs';
import { requestExperience } from '../network';
import type { EntitledTvod } from '../objects';

export type FetchTvodArgs = {
  page?: IndexPaging;
  config?: {
    vodMovie?: {
      typeId: number;
    };
    vodEpisode?: {
      typeId: number;
    };
  };
};

type FetchTvodListArgs = {
  variables: FetchTvodArgs;
  retrievedMetadata: string[];
};

/**
 * @see https://latest.api-docs-develop.ott.kaltura.com/api-docs/Experience_API/Query
 */
export async function fetchTvodList({ variables, retrievedMetadata }: FetchTvodListArgs) {
  const metadataKeys = retrievedMetadata.map((it) => `"${it}"`).join(', ');
  const res = await requestExperience<Query>(
    `
    query Query($config: ContextConfiguration, $page: IndexPaging) {
      commerce(contextConfiguration: $config) {
        entitlements {
          tvodList(page: $page) {
            pageIndex
            pageSize
            totalCount
            items {
              vod {
                id
                name
                type
                images {
                  imageType {
                    id
                    ratio {
                      name
                    }
                  }
                  url
                }
                ... on VodMovie {
                  metadata(
                    keys: [
                      ${metadataKeys}
                    ]
                  )
                }
                ... on VodEpisode {
                  episodeNumber
                  season {
                    seasonNumber
                  }
                  series {
                    seriesId
                  }
                  metadata(
                    keys: [
                      ${metadataKeys}
                    ]
                  )
                }
              }
            }
          }
        }
      }
    }
    `,
    variables,
  );

  const { items, totalCount } = res.data.commerce?.entitlements?.tvodList ?? {
    items: [] as EntitledTvod[],
    totalCount: 0,
  };

  return { items, totalCount };
}
